import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as routes from '../../../../constants/routes';
import { resetLegalAdviceQuestionResults, searchLegalAdviceQuestions } from '../../../../redux/actions';
import TopBanner from '../../sections/top_banner';
import QuestionResultsList from '../../sections/question_results_list';
import './index.scss';

const ResultsRoute = ({legalAdvicePage}) => {
    const { query } = useParams();

    const dispatch = useDispatch();

    const translations = useSelector((store) => store.config.Translations);
    const legalAdviceQuestionResults = useSelector((store) => store.data.legalAdviceQuestionResults);

    // Retrieve data from API
    useEffect(() => {
        dispatch(searchLegalAdviceQuestions({ query }));
        return () => dispatch(resetLegalAdviceQuestionResults());
    }, [query]);

    return legalAdviceQuestionResults && (
        <>
            <TopBanner
                legalAdvicePage={legalAdvicePage}
                additionalBreadcrumb={{
                    text: 'תוצאות חיפוש',
                    route: routes.legal_advice_routes.search_results,
                }}
            >
                <h3 className="banner-title banner-title_route_results">
                    {translations['legal_advice_results_title'] + ' '}
                    <span className="banner-highlighted-text">
                        {query}
                    </span>
                </h3>
            </TopBanner>

            <div className="legal-advice-results-route content-container content-container_narrow">
                <Link to={routes.legal_advice} className="results-return-link">
                    {translations['legal_advice_results_back_link']}
                </Link>

                {legalAdviceQuestionResults.length > 0 ? (
                    <QuestionResultsList legalAdvicePage={legalAdvicePage} data={legalAdviceQuestionResults} />
                ) : (
                    <p className="results-nothing-found">
                        {translations['legal_advice_no_results']}
                    </p>
                )}
            </div>
        </>
    );
};

export default ResultsRoute;
